const request = {
  outTime: "请求超时",
  downFail: "下载失败",
  Network: "网络错误"
} 
export default request